var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ExtraChargeClause"),
        width: "604px",
        "close-on-click-modal": false,
        "append-to-body": _vm.appendToBody
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.finalRowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "span",
        {
          style: _vm.appendToBody
            ? "width: 100%;display: inline-block;"
            : "padding:10px;",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "div",
            { staticStyle: { float: "left" } },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: { click: _vm.add }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabled, type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }